var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tes-table',_vm._b({staticClass:"simple-table",attrs:{"data":_vm.logsData,"columns":_vm.columns,"row-component":_vm.rowComponent}},'tes-table',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }